var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 21.26v-2.83a3.37 3.37 0 0 1 2.04-3.17c1.35-.6 2.6-1.03 3.75-1.3a15.25 15.25 0 0 1 7.2.1l-1.6 1.58c-.36-.04-.72-.08-1.08-.1a14.04 14.04 0 0 0-4.05.25c-.9.2-2.03.6-3.41 1.2-.34.15-.58.37-.72.64a1.8 1.8 0 0 0-.21.83v.88h8.9l1.92 1.92H.5Zm15.74.34-4.04-4.04 1.24-1.25 2.8 2.8 6.02-6.02 1.24 1.25-7.26 7.26Zm-6.53-9.78a4.31 4.31 0 0 1-3.17-1.23A4.28 4.28 0 0 1 5.3 7.41c0-1.3.42-2.36 1.24-3.18A4.31 4.31 0 0 1 9.71 3c1.3 0 2.37.41 3.2 1.23a4.28 4.28 0 0 1 1.24 3.18c0 1.3-.42 2.36-1.25 3.18a4.35 4.35 0 0 1-3.19 1.23Zm0-1.92A2.41 2.41 0 0 0 12.2 7.4 2.41 2.41 0 0 0 9.7 4.92a2.41 2.41 0 0 0-2.49 2.49A2.41 2.41 0 0 0 9.71 9.9Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.2d4d3b93b7a96ff46145fba71b7fff3a.svg";
export { ForwardRef as ReactComponent };